import { ApplicationController } from "../../application_controller"
import Rails from '@rails/ujs'

export default class extends ApplicationController {
    create(container_element) {
	let selectizeOptions = {
	    onChange: function(value) {
		var obj = $(this)[0]
		var select_element = obj.$input["0"]
		if ($(select_element).data('form-refresh')) {
		    var form_element = $(select_element).parents('form')[0]
		    var url = new URL(form_element.action)
		    url.searchParams.set('form_refresh', true)
		    form_element.action = url.href
		    Rails.fire(form_element, "submit")
		}

		if ($(select_element).data('form-fire')) {
		    var form_element = $(select_element).closest('form')[0]
		    Rails.fire(form_element, $(select_element).data('form-fire'))
		}
	    },
	    render: {
		item: function(data, escape) {
		    var self = this
		    var field_label = self.settings.labelField
		    var imageUrl = this.revertSettings.$children.filter(`option[value='${data.value}']`).data('image-url')

		    var item = '<div class="item">'
		    if (imageUrl) { item += `<img src="${imageUrl}">` }
		    item += escape(data[field_label])
		    item += '</div>'

		    return item
		},
		option: function(data, escape) {
		    var self = this
		    var field_label = self.settings.labelField
		    var imageUrl = this.revertSettings.$children.filter(`option[value='${data.value}']`).data('image-url')
		    var subline = this.revertSettings.$children.filter(`option[value='${data.value}']`).data('subline')

		    var option = '<div class="option">'
		    if (imageUrl) { option += `<img src="${imageUrl}">` }
		    option += escape(data[field_label])
		    if (subline) { option += `<span class="subline">${subline}</span>` }
		    option += '</div>'

		    return option
		}
	    }
	}

	$(container_element).find('select').each((i, element) => {
	    // Each select gets its own copy, so that create and load set for one select do not carry over to the next ones.
	    let elementSelectizeOptions = Object.assign({}, selectizeOptions)

	    if ($(element).data('allow-create')) {
		elementSelectizeOptions["create"] = true
	    }

	    if ($(element).data('allow-load-url')) {
		let load_url = $(element).data('allow-load-url')
		elementSelectizeOptions["load"] = function (query, callback) {
		    if (!query.length) return callback()

		    // Only the results of this search are shown. The selected items are kept by clearOptions.
		    this.clearOptions()
		    window.selectizeCallback = callback // the JS response will call this

		    Rails.ajax({
			url: load_url,
			type: 'GET',
			data: 'search=' + encodeURIComponent(query),
			dataType: 'script',
			error: function () { callback() }
		    })
		}
		// The server has already searched, so the results are not filtered again by their text.
		elementSelectizeOptions["score"] = function () { return function () { return 1 } }
	    }

	    $(element).selectize(elementSelectizeOptions)

	    // Needed for Chrome browsers...Anger...Peace.
	    $(element)[0].selectize.$control_input.attr("autocomplete", "disabled")
	})

	// Fix width / placeholder issues after layout settles
	requestAnimationFrame(() => {
	    requestAnimationFrame(() => {
		$(container_element).find('select').each((i, element) => {
		    var s = $(element)[0].selectize
		    if (s && s.items.length === 0) {
			s.$control_input.css('width', this.getPlaceholderWidth(s) + 'px')
		    }
		})
	    })
	})
    }

    destroy(container_element) {
	$(container_element).find('select').each((i, element) => {
	    if (element.selectize) {
		var value = $(element).val()
		element.selectize.destroy()
		$(element).val(value)
	    }
	})
    }

    getPlaceholderWidth(s) {
	const text = s.$control_input.attr('placeholder')

	const $tempSpan = $('<span/>')
            .text(text)
            .css({
		'position': 'absolute',
		'visibility': 'hidden',
		'white-space': 'nowrap',
		'font-family': s.$control_input.css('font-family'),
		'font-size': s.$control_input.css('font-size'),
		'font-weight': s.$control_input.css('font-weight'),
		'letter-spacing': s.$control_input.css('letter-spacing')
            })
            .appendTo('body')

	const width = $tempSpan.width()
	$tempSpan.remove()

	return width
    }
}
